var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('h6',{staticClass:"magic-link"},[(!_vm.calendar_subscription)?_c('span',{staticClass:"magic-link-message"},[_vm._v("Please wait! we are logging you in...")]):_c('span',{staticClass:"magic-link-message"},[_vm._v("Please wait! we are checking your payment status...")])])])
}
var staticRenderFns = []

export { render, staticRenderFns }